import { createAction } from 'redux-starter-kit';

export const putChecklistItem = createAction('PUT_CHECKLIST_ITEM');
export const putChecklistItems = createAction('PUT_CHECKLISTS_ITEMS');
export const putChecklistItemReferences = createAction('PUT_CHECKLIST_ITEM_REFERENCES');
